import {
  AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges,
  ViewEncapsulation,
  ChangeDetectorRef
} from '@angular/core';
import {Observable} from 'rxjs';
import {isNullOrUndefined, isNumber} from 'util';

@Component({
  selector: 'bw-chosen-plugins',
  templateUrl: 'chosen-plugins.component.html',
  styleUrls: ['chosen-plugins.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChosenPluginsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() iconValue: any;
  @Input() inputOptions: any;
  @Input() isChoosed: any;
  @Input() name: any;
  @Output() bwValueChange = new EventEmitter<string>();
  @Output() chosenValue = new EventEmitter<any>();

  plugins: any;
  chosedData: any;
  observable: any;
  isOptGroup= false;
  choiceData:any;

  constructor (private elementRef: ElementRef,public changeRef:ChangeDetectorRef) {
  }

  ngOnInit () {
    console.log(this.inputOptions,366,this.iconValue);
   if (!isNullOrUndefined(this.iconValue)) {
     this.inputOptions.valueObj.chosenValue = this.iconValue;
   }
   this.inputOptions.chosenItem.chosenOption.forEach((item) => {
      if (!isNullOrUndefined(item.optgroupLabel)) {
        console.log('进来了')
        this.isOptGroup = true;
        return;
      }
    });
  }

  ngAfterViewInit () {
    if (this.inputOptions.chosenItem.isMultiple) {
      this.inputOptions.valueObj.chosenValue.forEach((item) => {
        $(this.elementRef.nativeElement.querySelector('.chosen-select option[value=\'' + item + '\']')).attr('selected', 'selected');
      });
      $(this.elementRef.nativeElement.querySelector('.chosen-select')).trigger('liszt:updated');
    } else {
      $(this.elementRef.nativeElement.querySelector('.chosen-select option[value=\'' + this.inputOptions.valueObj.chosenValue + '\']'))
        .attr('selected', 'selected');
      $(this.elementRef.nativeElement.querySelector('.chosen-select')).trigger('liszt:updated');
    }
    ((options = {width: '100%'}) => {
      options = Object.assign(options, {search_contains: true, no_results_text: '没有找到匹配的项',
                                        placeholder_text_multiple: '', placeholder_text_single: ''});
      this.plugins = $(this.elementRef.nativeElement.querySelector('.chosen-select')).chosen(options);
    })(this.inputOptions.chosenItem);
    this.chosedData = this.inputOptions.valueObj.chosenValue;
    this.observable = Observable.fromEvent(this.plugins, 'change').subscribe((e) => {
      this.chosedData = $(this.elementRef.nativeElement.querySelector('.chosen-select')).val();
      if ((typeof this.inputOptions.valueObj.chosenValue) === 'object') {
        this.chosedData = this.chosedData.filter(value => value !== '');
      }
      this.chosenValue.emit(this.chosedData);
      if (!isNullOrUndefined(this.inputOptions.valueObj.appId)) {
        const obj = {
          appId: this.inputOptions.valueObj.appId,
          role: [
            {
              roleId: parseInt(this.plugins.get(0).value, 0)
            }
          ]
        };
        this.bwValueChange.emit(JSON.stringify(obj));
      }
    });
  }

  setIcon () {
    $($(this.elementRef.nativeElement.querySelector('.chosen-container'))[0].firstChild).addClass('chosen-span');
  }

  setChoosed (value) {
    this.elementRef.nativeElement.querySelectorAll('.chosen-select option').forEach(item => {
      if (isNaN(parseInt($(item)[0].value, 0))) {
        $(item)[0].selected = $(item)[0].value === value;
      } else if (isNumber(parseInt($(item)[0].value, 0))) {
        $(item)[0].selected = parseInt($(item)[0].value, 0) === parseInt(value, 0);
      }
    });
    $(this.elementRef.nativeElement.querySelector('.chosen-select')).trigger('liszt:updated');
    $(this.elementRef.nativeElement.querySelector('.chosen-select')).trigger('chosen:updated');
  }

  ngOnDestroy () {
    if (!isNullOrUndefined(this.observable)) {
      this.observable.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/chosen-plugins/chosen-plugins.component.ts